import React from 'react';
import type { Granularity } from '../../types/timeframe';
import styles from './aggregateBySelector.module.css';

interface AggregateBySelectorProps {
  value: Granularity;
  onChange: (granularity: Granularity) => void;
}

const OPTIONS: Array<{ value: Granularity; label: string }> = [
  { value: 'daily',     label: 'Daily' },
  { value: 'weekly',    label: 'Weekly' },
  { value: 'monthly',   label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
];

const AggregateBySelector: React.FC<AggregateBySelectorProps> = ({ value, onChange }) => (
  <div className={styles.container}>
    <p className={styles.heading}>AGGREGATE BY</p>
    <ul className={styles.list}>
      {OPTIONS.map(option => (
        <li
          key={option.value}
          className={`${styles.item} ${value === option.value ? styles.selected : ''}`}
          onClick={() => onChange(option.value)}
          role="button"
          aria-pressed={value === option.value}
          tabIndex={0}
          onKeyDown={e => e.key === 'Enter' && onChange(option.value)}
        >
          {option.label}
        </li>
      ))}
    </ul>
  </div>
);

export default AggregateBySelector;
